import { includedGuestsExceededItems } from 'lib/checkout/cartReservationUtils'

export function getBundleExtraGuestWarning(
  packages: Array<App.Package>,
  rooms: Array<App.Occupants> | undefined,
  offer: App.BundleOffer,
) {
  const matchingPackage = packages.find(pkg =>
    !pkg.roomRate?.extraGuestSurcharges.length && includedGuestsExceededItems(rooms || [], pkg, offer.bundledOffers[pkg.offerId]),
  )

  return {
    // A matching package can have no policy text and must still show the warning.
    showIncludedGuestsExceeded: !!matchingPackage,
    roomPolicyDescription: matchingPackage?.roomPolicyDescription,
  }
}
